var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"menuList"},_vm._l((_vm.menus),function(menu,i){return _c('li',{key:i},[_c('router-link',{attrs:{"to":{name: menu.route}},nativeOn:{"click":function($event){return _vm.toggleSpSlide()}}},[_vm._v(_vm._s(menu.label))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }